var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 243,
    viewBox: "0 0 328 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2393_46699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.498 107.579C274.405 103.655 269.751 95.4377 267.798 94.4081L230.628 76.7524C229.023 75.7051 227.363 75.1309 225.354 76.219L189.836 94.7946C188.708 95.4715 184.367 114.67 182.025 128.059",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.837 117.889C253.837 117.889 270.524 129.602 264.726 134.498C262.553 136.332 258.431 135.822 258.431 135.822C258.431 135.822 260.997 140.212 258.512 144.021C256.026 147.831 251.264 144.724 251.264 144.724C251.264 144.724 253.597 149.285 250.393 152.302C237.117 150.341 214.109 182.94 214.109 182.94L235.364 131.634",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.525 134.578C261.922 139.747 270.77 132.119 262.739 125.055",
    stroke: "#2B3F5F",
    strokeWidth: 1.28649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.74 125.051L258.269 119.418",
    stroke: "#2B3F5F",
    strokeWidth: 1.28649,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.375 94.8877C193.462 91.5774 214.045 81.531 223.137 77.1108C225.916 75.76 229.142 75.7404 231.944 77.0423L267.381 93.509C269.874 94.6674 271.8 96.775 272.73 99.3619L275.135 106.055",
    stroke: "#2B3F5F",
    strokeWidth: 1.28649,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.532 102.738L244.263 120.85L281.62 118.311L296.091 107.051L280.344 99.133L242.532 102.738Z",
    fill: "#2B3F5F",
    stroke: "white",
    strokeWidth: 1.28649
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.671 152.92C242.671 152.92 226.91 150.116 232.891 137.034C237.205 126.034 250.587 119.282 256.079 117.567C269.76 114.427 265.84 96.0665 251.164 101.423L229.331 106.878L211.555 117.732L182.092 119.727L177.997 167.672C181.739 185.465 199.197 196.856 216.99 193.114C223.559 185.106 236.766 177.653 243.744 154.118",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.59 125.616L180.952 125.531C180.954 125.519 180.956 125.508 180.958 125.497L181.59 125.616ZM177.997 167.672L177.355 167.711L177.355 167.711L177.997 167.672ZM216.991 193.114L217.488 193.522C217.395 193.635 217.267 193.713 217.123 193.743L216.991 193.114ZM236.466 171.729L235.952 171.342L236.466 171.729ZM186.743 94.7716C186.809 94.4225 187.145 94.1928 187.494 94.2585C187.843 94.3242 188.073 94.6605 188.007 95.0096L186.743 94.7716ZM244.267 153.981C244.377 153.643 244.739 153.458 245.077 153.567C245.415 153.676 245.601 154.039 245.491 154.377L244.267 153.981ZM181.59 125.616C182.227 125.702 182.227 125.702 182.227 125.702C182.227 125.702 182.227 125.703 182.227 125.703C182.227 125.704 182.227 125.706 182.227 125.707C182.226 125.711 182.225 125.717 182.224 125.724C182.222 125.74 182.219 125.762 182.215 125.792C182.207 125.852 182.195 125.941 182.18 126.057C182.149 126.29 182.104 126.633 182.047 127.074C181.932 127.956 181.77 129.227 181.576 130.785C181.19 133.903 180.681 138.168 180.192 142.762C179.212 151.975 178.322 162.431 178.639 167.633L177.355 167.711C177.03 162.38 177.936 151.808 178.913 142.626C179.402 138.023 179.912 133.749 180.3 130.627C180.493 129.066 180.656 127.792 180.771 126.908C180.828 126.467 180.874 126.122 180.905 125.888C180.92 125.772 180.932 125.682 180.94 125.622C180.944 125.592 180.947 125.569 180.949 125.554C180.95 125.546 180.951 125.54 180.951 125.536C180.952 125.535 180.952 125.533 180.952 125.532C180.952 125.532 180.952 125.531 180.952 125.531C180.952 125.531 180.952 125.531 181.59 125.616ZM178.639 167.633C179.179 176.46 184.332 183.583 191.576 188.055C198.825 192.53 208.128 194.32 216.859 192.484L217.123 193.743C208.061 195.649 198.422 193.793 190.9 189.149C183.372 184.502 177.925 177.033 177.355 167.711L178.639 167.633ZM216.494 192.706C219.802 188.673 222.999 185.559 226.19 182.351C229.384 179.14 232.586 175.82 235.952 171.342L236.98 172.115C233.559 176.666 230.307 180.036 227.103 183.258C223.895 186.483 220.749 189.547 217.488 193.522L216.494 192.706ZM180.958 125.497L186.743 94.7716L188.007 95.0096L182.222 125.735L180.958 125.497ZM235.952 171.342C238.304 168.213 240.383 163.886 241.881 160.309C242.627 158.527 243.225 156.943 243.635 155.804C243.84 155.235 243.999 154.778 244.106 154.464C244.159 154.307 244.2 154.185 244.227 154.104C244.241 154.063 244.251 154.032 244.258 154.011C244.261 154.001 244.263 153.993 244.265 153.988C244.266 153.986 244.266 153.984 244.267 153.983C244.267 153.982 244.267 153.982 244.267 153.981C244.267 153.981 244.267 153.981 244.267 153.981C244.267 153.981 244.267 153.981 244.879 154.179C245.491 154.377 245.491 154.377 245.491 154.377C245.491 154.377 245.491 154.378 245.491 154.378C245.491 154.378 245.491 154.379 245.491 154.38C245.49 154.381 245.489 154.383 245.488 154.386C245.487 154.392 245.484 154.4 245.48 154.411C245.473 154.433 245.462 154.466 245.448 154.508C245.42 154.593 245.378 154.718 245.324 154.878C245.215 155.199 245.054 155.664 244.845 156.241C244.429 157.395 243.824 159 243.067 160.806C241.559 164.407 239.432 168.855 236.98 172.115L235.952 171.342Z",
    fill: "#2B3F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.726 100.869L232.056 97.5336C231.103 97.3799 230.136 97.4396 229.213 97.7199C224.839 99.0475 211.46 103.197 207.667 105.415",
    stroke: "#2B3F5F",
    strokeWidth: 1.28649,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.018 119.325C199.158 125.001 208.092 131.334 214.697 122.922",
    stroke: "#2B3F5F",
    strokeWidth: 1.28649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.311 144.102C255.639 149.313 263.312 140.761 256.524 134.578",
    stroke: "#2B3F5F",
    strokeWidth: 1.28649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.193 152.383C247.5 157.638 255.673 149.434 250.312 144.102",
    stroke: "#2B3F5F",
    strokeWidth: 1.28649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.883 152.966L231.997 139.812",
    stroke: "#2B3F5F",
    strokeWidth: 1.28649,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.312 144.098L239.306 131.098",
    stroke: "#2B3F5F",
    strokeWidth: 1.28649,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.526 134.576L246.614 122.387",
    stroke: "#2B3F5F",
    strokeWidth: 1.28649,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.815 182.85C236.341 161.462 226.91 150.114 232.891 137.033C237.204 126.033 250.587 119.28 256.078 117.566C269.759 114.425 265.84 96.0653 251.163 101.421C251.163 101.421 236.001 105.13 231.235 108.12C226.602 111.025 214.697 122.923 214.697 122.923",
    stroke: "#2B3F5F",
    strokeWidth: 1.28649,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.979 127.905C187.478 128.144 185.257 126.31 185.018 123.81L180.49 124.242C180.968 129.244 185.41 132.911 190.411 132.433L210.788 130.486C212.038 130.367 212.955 129.256 212.835 128.006C212.716 126.756 211.605 125.839 210.355 125.958L189.979 127.905Z",
    fill: "#2B3F5F",
    stroke: "white",
    strokeWidth: 1.28649
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.66 108.072C167.185 108.308 165.369 110.507 165.606 112.982L166.48 122.13C166.716 124.605 168.915 126.42 171.39 126.184L182.756 125.098L181.026 106.986L169.66 108.072Z",
    fill: "#2B3F5F",
    stroke: "white",
    strokeWidth: 1.28649
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.027 106.984L182.758 125.096L210.031 124.942L230.388 106.693L181.027 106.984Z",
    fill: "#2B3F5F",
    stroke: "white",
    strokeWidth: 1.28649
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.127 152.121L178.436 139.393L218.944 191.793L198.158 211.666L152.127 152.121Z",
    fill: "white",
    stroke: "#2B3F5F",
    strokeWidth: 1.28649
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6625 249.179C67.7372 191.591 144.243 150.482 151.973 151.921L196.825 209.941C199.333 238.764 112.211 289.411 104.037 371.064L69.958 309.864L33.6625 249.179Z",
    fill: "#2B3F5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1619 250.324L104.618 372.624C109.254 332.07 134.485 298.22 156.028 272.154C160.529 266.707 164.959 261.561 169.152 256.689C175.274 249.576 180.893 243.047 185.499 237.022C189.369 231.96 192.478 227.31 194.531 223.038C196.52 218.899 197.476 215.203 197.247 211.892L151.783 153.081C151.458 153.091 150.979 153.153 150.323 153.305C149.37 153.525 148.161 153.903 146.714 154.444C143.825 155.523 140.059 157.222 135.633 159.496C126.785 164.042 115.351 170.862 103.092 179.555C78.7107 196.847 51.1526 221.491 34.1619 250.324ZM149.624 151.179C150.642 150.944 151.58 150.826 152.301 150.967L152.735 151.051L199.279 211.259L199.312 211.61C199.688 215.566 198.568 219.765 196.44 224.194C194.306 228.634 191.111 233.397 187.212 238.497C182.585 244.55 176.9 251.157 170.741 258.313C166.551 263.182 162.142 268.305 157.699 273.682C135.663 300.344 110.185 334.765 106.41 376.04L106.136 379.033L31.6981 250.104L32.0103 249.57C49.1575 220.193 77.1318 195.179 101.759 177.713C114.08 168.975 125.585 162.111 134.514 157.524C138.977 155.231 142.809 153.5 145.786 152.387C147.273 151.832 148.564 151.424 149.624 151.179Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2393_46699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163.751,
    height: 163.751,
    fill: "white",
    transform: "matrix(-0.546442 0.837497 0.837497 0.546442 185.901 9.74609)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.114a4147f9731ef8d67c8c0f1ac9390e.svg";
export { ForwardRef as ReactComponent };